<script lang="ts">
  import AuditLogPanel from "../lib/AuditLogPanel.svelte";
  import DiagnosticLogPanel from "../lib/DiagnosticLogPanel.svelte";

  let tab: "audit" | "diagnostic" = "audit";
  /** Lazy-mount the diagnostic panel only after the tab is first shown. */
  let diagSeen = false;

  function show(t: "audit" | "diagnostic") {
    tab = t;
    if (t === "diagnostic") diagSeen = true;
  }
</script>

<section>
  <h1>Logs</h1>
  <div class="tabs" data-testid="logs-tabs">
    <button
      class:active={tab === "audit"}
      on:click={() => show("audit")}
      data-testid="tab-audit"
    >
      Audit log
    </button>
    <button
      class:active={tab === "diagnostic"}
      on:click={() => show("diagnostic")}
      data-testid="tab-diagnostic"
    >
      Diagnostic log
    </button>
  </div>

  {#if tab === "audit"}
    <div class="pane" data-testid="pane-audit">
      <AuditLogPanel />
    </div>
  {:else}
    <div class="pane" data-testid="pane-diagnostic">
      {#if diagSeen}
        <DiagnosticLogPanel />
      {/if}
    </div>
  {/if}
</section>

<style>
  h1 {
    margin: 0 0 1rem;
  }
  .tabs {
    display: flex;
    gap: 0.25rem;
    margin: 0.5rem 0 1rem;
    flex-wrap: wrap;
  }
  .tabs button {
    padding: 0.4rem 0.8rem;
    background: #111827;
    color: #9ca3af;
    border: 1px solid #1f2937;
    border-radius: 6px;
    cursor: pointer;
  }
  .tabs button.active {
    background: #1f2937;
    color: #f3f4f6;
    border-color: #374151;
  }
</style>
